import { Navigate } from "react-router-dom";
import { usePermissions } from "./context/PermissionContext";
import { useRole } from "./context/RoleContext";
import Loading from "./components/Loading";

const ProtectedRoute = ({ permission, children }) => {
  const { permissions, loading } = usePermissions();
  const { role } = useRole();

  if (loading) {
    return <Loading />; 
  }

  const hasPermission = permissions.includes(permission);
  const isAdmin = role === "superadmin" || role === "admin";

  if (!hasPermission && !isAdmin) {
    return <Navigate to={`/${role}/dashboard`} replace />;
  }

  return children;
};

export default ProtectedRoute;